import React from 'react';

import Grid from '@components-clean/core/grid/index';
import { GridDummyColumns, GridDummyData } from '@pages-clean/dummy-page/dummy-page.data';

const GridPage = () => {
    return (
        <Grid
            title="Core OPRA Grid Without Card"
            maxHeight="calc(100vh - 136px)"
            testDataId="dummy-grid"
            data={GridDummyData}
            columns={GridDummyColumns}
            canEdit
            filterable={false}
        />
    );
};

export default GridPage;
